import { HttpClient } from "@angular/common/http";
import { inject, Injectable, provideAppInitializer } from "@angular/core";
import { EMPTY } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Environment } from "../../../environments/environment.model";
import { environment } from "../../../environments/environment";
import { CmsStoreRepository } from "../repositories/cms-data.repository";
import { FormioAppConfig } from "@formio/angular";

@Injectable({ providedIn: "root" })
export class ConfigService {
    private http = inject(HttpClient);

    public loadConfig$(): Promise<unknown> {
        return new Promise((resolve, reject) => {
            this.http
                .get<Environment>(`/environment`)
                .pipe(
                    tap((data: Environment) => {
                        this.setEnvironmentVariables(data);
                        resolve(true);
                    }),
                    catchError(() => {
                        console.log("environment load error");
                        this.setFavicon();
                        resolve(true);
                        return EMPTY;
                    })
                ).subscribe({
                    next: () => resolve(true),
                    error: (err) => reject(err)
                });
        });
    }

    private setEnvironmentVariables(config: Environment) {
        environment.production = config.production;
        environment.appVersion = config.appVersion;
        environment.authConfig = config.authConfig;
        environment.backendUrl = config.backendUrl;
        environment.cmsCacheExpiration = config.cmsCacheExpiration;
        environment.formioPremiumLicense = config.formioPremiumLicense;
        environment.checkFogpForms = config.checkFogpForms;
        environment.fogpRedirectUrl = config.fogpRedirectUrl;
        environment.favicon = config.favicon;
        this.setFavicon();
    }

    private setFavicon() {
        const link: HTMLLinkElement = document.querySelector('link[rel="icon"]')!;

        if (!link) return;
        if (environment.favicon === "red") {
            link.href = "favicon_red_rgb.ico";
        } else if (environment.favicon === "black") {
            link.href = "favicon_black_rgb.ico";
        } else {
            link.href = "favicon_knap_rgb.ico";
        }
    }
}

export function configFactory(configService: ConfigService, cmsService: CmsStoreRepository) {
    return () => configService.loadConfig$()
        .then(() => {
            new Promise((resolve, reject) => {
                cmsService.loadCmsData$().subscribe({
                    next: () => resolve(true),
                    error: (err) => reject(err)
                });
            });
        });
};

export const provideConfig = provideAppInitializer(() => {
    const initializerFn = (configFactory)(inject(ConfigService), inject(CmsStoreRepository));
    return initializerFn();
})

export const provideFormioAppConfig = {
    provide: FormioAppConfig,
    useValue: {}
}